// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"d19f5349","137":"040a6fb6","981":"51033ce4"}[chunkId] + ".chunk.css";
};